import { fetcher } from '../utils'

export default async (connectionKey: string, phoneNumber: string): Promise<void> =>
  fetcher(`/api/chats/${connectionKey}/${phoneNumber}/sessions/finish`, 'DELETE', undefined)
